import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Get, Param, Query, Req } from '@nestjs/common';
import { ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { NotificationsService } from './notifications.service';
import { NotifyResponseModel } from './notify-res-model';

@ApiTags('Notifications')
@Controller('notifications')
export class NotificationsController {
    constructor (
        private notifyService: NotificationsService ,
    ){}

    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })  
    @Get('/getNotifications/:userId') 
    @ApiOperation({summary:'typeid: 1 means post related, 2 means - livetv, 3 means profile, 4 means representation '})
    @ApiParam({name:'userId'})
    @ApiQuery({name:'apiVersion'})
    async getNotifications(@Query() params,@Param('userId') userId, @Req() request:Request):Promise<NotifyResponseModel> {
        try {
            return await this.notifyService.getNotifications(params,userId,request);
        } catch (error) {
            return errorHandler(NotifyResponseModel, error);
        }
    }
}
